// extracted by mini-css-extract-plugin
export default {"search":"search___kFuPH","searchStyle":"searchStyle___PVzKn"};